import { lazy } from 'react';

const RELOAD_FLAG = 'founderos_chunk_reload_ts';
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

/**
 * React.lazy with resilience: retries a failed dynamic import once (network
 * blip), and if the chunk is permanently gone (stale hash after a redeploy)
 * forces a one-time full reload so the user never sees a broken page.
 */
export const lazyRetry = (importer) => lazy(async () => {
  try {
    const m = await importer();
    sessionStorage.removeItem(RELOAD_FLAG);
    return m;
  } catch {
    await sleep(700);
    try {
      const m = await importer();
      sessionStorage.removeItem(RELOAD_FLAG);
      return m;
    } catch (err2) {
      const last = Number(sessionStorage.getItem(RELOAD_FLAG) || 0);
      if (Date.now() - last > 15000) {
        sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
        window.location.reload();
        return new Promise(() => {});
      }
      throw err2;
    }
  }
});

export default lazyRetry;
